module.exports = new __parcel__URL__("Mageskill_31.c689b5f7.png").toString();